export const notification = {
    breadcrumb: {
        notifications: 'Notifications',
    },
    tab: {
        pending: 'Pending',
        approved: 'Approved',
        rejected: 'Rejected',
    },
    table: {
        fullName: 'Full name',
        email: 'Email',
        lastAction: 'Last action',
        projectManagerEmail: 'Project manager email',
        projectName: 'Project name',
        requestedAction: 'Requested action',
        date: 'Date',
        action: 'Action',
        reject: 'Reject',
        updatedBy: 'Updated by',
        reason: 'Reason',
        actionRequired: {
            resetPassword: 'Waiting to reset password',
            setPassword: 'Waiting to set password',
        },
        actions: {
            resetPassword: 'Reset password',
            setPassword: 'Set password',
            ldapImport: 'LDAP import',
            register: 'Register',
            confirm: 'Confirm',
        },
    },
    message: {
        reject: {
            success: 'The notification has been rejected',
        },
    },
    form: {
        title: 'Reject',
        rejectReason: {
            label: 'Reason',
            placeholder: 'Enter reason',
        },
        button: {
            save: 'Save',
        },
    },
    filterForm: {
        keyword: {
            label: 'Keyword',
            placeholder: 'Keyword',
        },
        project: {
            label: 'Project',
            placeholder: 'Project',
        },
    },
};
